import React from 'react';
import SkeletonAnimation from '../../../../hoc/skeletonAnimation/SkeletonAnimation';

const LatestArticleSkeleton = ({ skeletonClass }) => {
  return (
    <div className="flex flex-row gap-[30px] items-center">
      <div className={`flex flex-col gap-[24px] w-[445px]`}>
        <h1 className={`h-[44px] bg-[#E9E9E9] ${skeletonClass}`}></h1>
        <div className={`lg:hidden w-[344px] h-[240px] overflow-hidden rounded-[5px] bg-[#E9E9E9] ${skeletonClass}`}></div>
        <span className={`px-[21px] py-[5px] rounded-[20px] w-[150px] whitespace-nowrap h-[25px] bg-[#E9E9E9] ${skeletonClass}`}></span>
        <p className={`h-[78px] bg-[#E9E9E9] ${skeletonClass}`}></p>
        <p className={`h-[20px] bg-[#E9E9E9] ${skeletonClass}`}></p>
      </div>
      <div className={`lg:flex hidden w-[635px] h-[400px] overflow-hidden rounded-[5px] bg-[#E9E9E9] ${skeletonClass}`}></div>
    </div>
  );
};

export default SkeletonAnimation(LatestArticleSkeleton);
